<div class="device-list-container">
    <div class="table-row table-header">
        <div class="column fcu-unit-no">
            {{ 'device-list.unit.header.fcu-index' | translate }}
        </div>
        <div class="column fu-unit-no">
            {{ 'device-list.unit.header.index' | translate: { deviceType } }}
        </div>
        <div class="column model">
            {{ 'device-list.unit.header.model' | translate }}
        </div>
        <div class="column item-code">
            {{ 'device-list.unit.header.item-code' | translate }}
        </div>
        <div class="column description">
            {{ 'device-list.unit.header.description' | translate }}
        </div>
        <div class="column options"></div>
    </div>
    <div *ngFor="let unit of units; index as i" class="table-row" [class.expanded]="isUnitExpanded(unit)">
        <div class="column fcu-unit-no semibold">
            {{ unit.fcuIndex }}
        </div>
        <div class="column fu-unit-no semibold">
            {{ unit.index }}
        </div>
        <app-device-model-dropdown
            class="column model"
            [modelOptions]="models"
            [unitModel]="getUnitModel(unit)"
            (onModelSelected)="handleModelSelected($event, unit)">
        </app-device-model-dropdown>

        <div class="column item-code" [class.emptyCell]="!getModelItemCode(unit)">
            {{ getModelItemCode(unit) ? getModelItemCode(unit) : '-' }}
        </div>

        <app-description-cell
            class="description"
            [description]="getModelDescription(unit)"
            (expandedChange)="setUnitExpanded(unit, $event)"></app-description-cell>

        <div class="column options" #optionsCol>
            <mat-icon svgIcon="more-options" class="icon" (click)="openUnitOptions(unit, i)" />
            <div class="options-container" *ngIf="openedUnitOptions == unit" [style.top]="optionsTop">
                <div class="option-row" (click)="deleteUnit(unit)">
                    <mat-icon svgIcon="delete" class="delete-icon icon-margin" />
                    {{ 'dlg.clear' | translate }}
                </div>
            </div>
        </div>
    </div>
</div>
